import HomeBanner from "./Components/HomeBanner/HomeBanner";
import HomeHistorySteps from "./Components/HomeHistorySteps/HomeHistorySteps";
import LocalServices from "./Components/LocalServices/LocalServices";
import LocationBasedProperty from "./Components/LocationBasedProperty/LocationBasedProperty";
import PropertyInfo from "./Components/PropertyInfo/PropertyInfo";
import Partners from "./Components/Partners/Partners";
import RecentlyAdded from "./Components/RecentlyAdded/RecentlyAdded";
import CityListLinks from "./Components/CityListLinks/CityListLinks";
import StateListLinks from "./Components/StateListLinks/StateListLinks";

const HomePage = () => {
  return (
    <>
      {/* 1 — Hero */}
      <HomeBanner />
      {/* 2 — Home History steps (We find / You build / Stays with the home) */}
      <HomeHistorySteps />
      {/* 3 — Vendors / Local Services */}
      <LocalServices />
      {/* 4 — Properties */}
      <LocationBasedProperty />
      {/* 5 — Secure your home in three simple steps (Find / Claim / Lock) */}
      <PropertyInfo />
      {/* 6 — Integrations to power the future of your property */}
      <Partners />
      {/* 7 — Recently added homes */}
      <RecentlyAdded />
      {/* 8 — Search for homes by city / state */}
      <CityListLinks />
      <StateListLinks />
    </>
  );
};

export default HomePage;
